import type { PaymentLink } from "../types/payment-links"
import { subDays, subHours, addDays } from "date-fns"

export const mockPaymentLinks: PaymentLink[] = [
  {
    id: "plink_1",
    name: "Premium Subscription",
    description: "Monthly premium subscription plan with full access to all features, priority support, and unlimited usage.",
    status: "active",
    price: 2999,
    amount: 2999,
    type: "subscription",
    linkType: "cause-service",
    revenue30d: 89971,
    successRate: 92.5,
    lastUsed: subHours(new Date(), 2),
    lastUsedAt: subHours(new Date(), 2).toISOString(),
    created: subDays(new Date(), 30).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/premium-subscription",
    shortCode: "prem-sub-2024",
    views: 1250,
    viewsCount: 1250,
    conversions: 156,
    conversionsCount: 156,
    totalRevenue: 89971,
    maxUses: 500,
    currentUses: 156,
    expiresAt: addDays(new Date(), 60).toISOString(),
    paymentDescriptor: "ACME*PREMIUM",
    minimumAmount: 2999,
    maximumAmount: 2999,
    allowShippingDetails: false,
    allowPhoneNumber: true,
    requirePhoneNumber: false,
    allowSaveCard: true,
    allowTaxSupport: true,
    taxPercentage: 8.25,
    afterPaymentBehavior: "confirmation",
    successUrl: "https://app.example.com/welcome",
    paymentPageImageUrl: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=300&fit=crop",
    afterPaymentImageUrl: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=400&h=300&fit=crop",
  },
  {
    id: "plink_2",
    name: "Product Purchase",
    description: "Shop our curated collection of premium products.",
    status: "active",
    price: 9999,
    amount: 9999,
    type: "fixed",
    linkType: "products-subscriptions",
    revenue30d: 299980,
    successRate: 87.3,
    lastUsed: subHours(new Date(), 5),
    lastUsedAt: subHours(new Date(), 5).toISOString(),
    created: subDays(new Date(), 15).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/product-purchase",
    shortCode: "prod-purch",
    views: 2100,
    viewsCount: 2100,
    conversions: 183,
    conversionsCount: 183,
    totalRevenue: 299980,
    maxUses: 1000,
    currentUses: 183,
    expiresAt: addDays(new Date(), 90).toISOString(),
    paymentDescriptor: "ACME*STORE",
    allowShippingDetails: true,
    allowPhoneNumber: true,
    requirePhoneNumber: true,
    allowSaveCard: true,
    allowTaxSupport: true,
    taxPercentage: 10,
    afterPaymentBehavior: "redirect",
    successUrl: "https://shop.example.com/thank-you",
    cartItems: JSON.stringify([
      { id: "item_1", name: "Wireless Headphones Pro", description: "Active noise cancelling, 40hr battery", price: 4999, quantity: 1 },
      { id: "item_2", name: "USB-C Charging Cable (3-pack)", description: "Braided, fast-charge compatible", price: 1499, quantity: 2 },
      { id: "item_3", name: "Leather Laptop Sleeve", description: "Fits up to 15\" MacBook", price: 3499, quantity: 1 },
    ]),
  },
  {
    id: "plink_3",
    name: "Charity Donation",
    description: "Help us make a difference. Every dollar counts towards building a better future for underprivileged children.",
    status: "active",
    type: "donation",
    linkType: "cause-service",
    revenue30d: 12450,
    successRate: 65.2,
    lastUsed: subHours(new Date(), 1),
    lastUsedAt: subHours(new Date(), 1).toISOString(),
    created: subDays(new Date(), 60).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/charity-donation",
    shortCode: "charity-2024",
    views: 950,
    viewsCount: 950,
    conversions: 62,
    conversionsCount: 62,
    totalRevenue: 12450,
    minimumAmount: 500,
    maximumAmount: 100000,
    presetAmounts: "500,1000,2500,5000,10000",
    allowPhoneNumber: false,
    allowSaveCard: false,
    afterPaymentBehavior: "confirmation",
  },
  {
    id: "plink_4",
    name: "Annual Membership",
    description: "12-month membership with exclusive benefits and early access to new features.",
    status: "inactive",
    price: 19999,
    amount: 19999,
    type: "subscription",
    linkType: "cause-service",
    revenue30d: 39998,
    successRate: 71.8,
    lastUsed: subDays(new Date(), 3),
    lastUsedAt: subDays(new Date(), 3).toISOString(),
    created: subDays(new Date(), 90).toISOString(),
    updated: new Date().toISOString(),
    deactivated: subDays(new Date(), 1),
    currency: "USD",
    url: "https://pay.example.com/annual-membership",
    shortCode: "annual-mem",
    views: 1800,
    viewsCount: 1800,
    conversions: 129,
    conversionsCount: 129,
    totalRevenue: 39998,
    maxUses: 200,
    currentUses: 129,
    paymentDescriptor: "ACME*ANNUAL",
    allowSaveCard: true,
    afterPaymentBehavior: "invoice",
  },
  {
    id: "plink_5",
    name: "Event Ticket",
    description: "General admission ticket for the annual developer conference.",
    status: "inactive",
    price: 29999,
    amount: 29999,
    type: "one-time",
    linkType: "cause-service",
    revenue30d: 0,
    successRate: 94.1,
    lastUsed: subDays(new Date(), 10),
    lastUsedAt: subDays(new Date(), 10).toISOString(),
    created: subDays(new Date(), 120).toISOString(),
    updated: new Date().toISOString(),
    deactivated: subDays(new Date(), 5),
    currency: "USD",
    url: "https://pay.example.com/event-ticket",
    shortCode: "event-tix",
    views: 750,
    viewsCount: 750,
    conversions: 0,
    conversionsCount: 0,
    totalRevenue: 0,
    expiresAt: subDays(new Date(), 5).toISOString(),
    allowShippingDetails: false,
    allowPhoneNumber: true,
    requirePhoneNumber: true,
    afterPaymentBehavior: "confirmation",
  },
  {
    id: "plink_6",
    name: "Basic Plan",
    description: "Entry-level plan with essential features for individual users.",
    status: "active",
    price: 999,
    amount: 999,
    type: "subscription",
    linkType: "cause-service",
    revenue30d: 54945,
    successRate: 78.9,
    lastUsed: subHours(new Date(), 8),
    lastUsedAt: subHours(new Date(), 8).toISOString(),
    created: subDays(new Date(), 45).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/basic-plan",
    shortCode: "basic-plan",
    views: 2800,
    viewsCount: 2800,
    conversions: 221,
    conversionsCount: 221,
    totalRevenue: 54945,
    paymentDescriptor: "ACME*BASIC",
    allowSaveCard: true,
    afterPaymentBehavior: "redirect",
    successUrl: "https://app.example.com/get-started",
  },
  {
    id: "plink_7",
    name: "Workshop Registration",
    description: "Half-day hands-on workshop with industry experts. Materials included.",
    status: "active",
    price: 14999,
    amount: 14999,
    type: "fixed",
    linkType: "products-subscriptions",
    revenue30d: 194987,
    successRate: 82.4,
    lastUsed: subHours(new Date(), 3),
    lastUsedAt: subHours(new Date(), 3).toISOString(),
    created: subDays(new Date(), 25).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/workshop-registration",
    shortCode: "workshop-reg",
    views: 1500,
    viewsCount: 1500,
    conversions: 124,
    conversionsCount: 124,
    totalRevenue: 194987,
    maxUses: 50,
    currentUses: 42,
    expiresAt: addDays(new Date(), 14).toISOString(),
    allowPhoneNumber: true,
    requirePhoneNumber: true,
    allowShippingDetails: false,
    afterPaymentBehavior: "confirmation",
    cartItems: JSON.stringify([
      { id: "ws_1", name: "Workshop Seat - Full Day", description: "Advanced React Patterns Workshop", price: 12999, quantity: 1 },
      { id: "ws_2", name: "Workshop Materials Kit", description: "Printed handbook & code samples USB", price: 2000, quantity: 1 },
    ]),
  },
  {
    id: "plink_8",
    name: "Digital Download",
    description: "Instant access to our premium digital content bundle.",
    status: "active",
    price: 4999,
    amount: 4999,
    type: "one-time",
    linkType: "cause-service",
    revenue30d: 24995,
    successRate: 91.2,
    lastUsed: subHours(new Date(), 6),
    lastUsedAt: subHours(new Date(), 6).toISOString(),
    created: subDays(new Date(), 75).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/digital-download",
    shortCode: "dig-dl",
    views: 1200,
    viewsCount: 1200,
    conversions: 109,
    conversionsCount: 109,
    totalRevenue: 24995,
    afterPaymentBehavior: "redirect",
    successUrl: "https://downloads.example.com/access",
  },
  {
    id: "plink_9",
    name: "Team License",
    status: "inactive",
    price: 49999,
    amount: 49999,
    type: "subscription",
    linkType: "cause-service",
    revenue30d: 0,
    successRate: 68.5,
    lastUsed: subDays(new Date(), 7),
    lastUsedAt: subDays(new Date(), 7).toISOString(),
    created: subDays(new Date(), 100).toISOString(),
    updated: new Date().toISOString(),
    deactivated: subDays(new Date(), 2),
    currency: "USD",
    url: "https://pay.example.com/team-license",
    shortCode: "team-lic",
    views: 650,
    viewsCount: 650,
    conversions: 0,
    conversionsCount: 0,
    totalRevenue: 0,
  },
  {
    id: "plink_10",
    name: "Support Fund",
    description: "Contribute to our open-source sustainability fund.",
    status: "active",
    type: "donation",
    linkType: "cause-service",
    revenue30d: 8750,
    successRate: 73.6,
    lastUsed: subHours(new Date(), 4),
    lastUsedAt: subHours(new Date(), 4).toISOString(),
    created: subDays(new Date(), 50).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/support-fund",
    shortCode: "support-fund",
    views: 1400,
    viewsCount: 1400,
    conversions: 103,
    conversionsCount: 103,
    totalRevenue: 8750,
    minimumAmount: 100,
    maximumAmount: 50000,
    presetAmounts: "500,1000,2500,5000",
    afterPaymentBehavior: "confirmation",
  },
  {
    id: "plink_11",
    name: "Blocked Service A",
    status: "blocked",
    price: 5999,
    amount: 5999,
    type: "subscription",
    linkType: "cause-service",
    revenue30d: 0,
    successRate: 0,
    lastUsed: subDays(new Date(), 15),
    created: subDays(new Date(), 80).toISOString(),
    updated: new Date().toISOString(),
    deactivated: subDays(new Date(), 15),
    currency: "USD",
    url: "https://pay.example.com/blocked-service-a",
    views: 820,
    conversions: 0,
    totalRevenue: 0,
  },
  {
    id: "plink_12",
    name: "Blocked Product B",
    status: "blocked",
    price: 12999,
    amount: 12999,
    type: "one-time",
    linkType: "cause-service",
    revenue30d: 0,
    successRate: 0,
    lastUsed: subDays(new Date(), 22),
    created: subDays(new Date(), 110).toISOString(),
    updated: new Date().toISOString(),
    deactivated: subDays(new Date(), 22),
    currency: "USD",
    url: "https://pay.example.com/blocked-product-b",
    views: 590,
    conversions: 0,
    totalRevenue: 0,
  },
  {
    id: "plink_13",
    name: "Enterprise SaaS License",
    description: "Enterprise-grade SaaS platform license with dedicated support and SLA guarantees.",
    status: "active",
    price: 249900,
    amount: 249900,
    type: "subscription",
    linkType: "cause-service",
    revenue30d: 749700,
    successRate: 96.8,
    lastUsed: subHours(new Date(), 1),
    lastUsedAt: subHours(new Date(), 1).toISOString(),
    created: subDays(new Date(), 10).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/enterprise-saas",
    shortCode: "ent-saas",
    views: 320,
    viewsCount: 320,
    conversions: 31,
    conversionsCount: 31,
    totalRevenue: 749700,
    paymentDescriptor: "ACME*ENTERPRISE",
    allowSaveCard: true,
    allowPhoneNumber: true,
    requirePhoneNumber: true,
    afterPaymentBehavior: "invoice",
  },
  {
    id: "plink_14",
    name: "Conference Pass 2026",
    description: "Full conference pass including all keynotes, workshops, and networking events.",
    status: "active",
    price: 59900,
    amount: 59900,
    type: "one-time",
    linkType: "products-subscriptions",
    revenue30d: 1437600,
    successRate: 89.5,
    lastUsed: subHours(new Date(), 2),
    lastUsedAt: subHours(new Date(), 2).toISOString(),
    created: subDays(new Date(), 20).toISOString(),
    updated: new Date().toISOString(),
    currency: "EUR",
    url: "https://pay.example.com/conference-pass-2026",
    shortCode: "conf-2026",
    views: 3500,
    viewsCount: 3500,
    conversions: 240,
    conversionsCount: 240,
    totalRevenue: 1437600,
    maxUses: 500,
    currentUses: 240,
    expiresAt: addDays(new Date(), 45).toISOString(),
    allowShippingDetails: true,
    allowPhoneNumber: true,
    afterPaymentBehavior: "confirmation",
    cartItems: JSON.stringify([
      { id: "conf_1", name: "Conference Pass - Full Access", description: "3-day all-access pass", price: 49900, quantity: 1 },
      { id: "conf_2", name: "Workshop Add-on", description: "Half-day pre-conference workshop", price: 10000, quantity: 1 },
    ]),
  },
  {
    id: "plink_15",
    name: "Monthly Coaching",
    description: "One-on-one monthly coaching sessions with a certified professional.",
    status: "active",
    price: 19900,
    amount: 19900,
    type: "subscription",
    linkType: "cause-service",
    revenue30d: 159200,
    successRate: 83.7,
    lastUsed: subHours(new Date(), 4),
    lastUsedAt: subHours(new Date(), 4).toISOString(),
    created: subDays(new Date(), 40).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/monthly-coaching",
    shortCode: "coaching",
    views: 1850,
    viewsCount: 1850,
    conversions: 155,
    conversionsCount: 155,
    totalRevenue: 159200,
    paymentDescriptor: "ACME*COACHING",
    allowSaveCard: true,
    afterPaymentBehavior: "redirect",
    successUrl: "https://coaching.example.com/schedule",
  },
  {
    id: "plink_16",
    name: "Freelancer Invoice #2847",
    description: "Invoice for web development services rendered in January 2026.",
    status: "active",
    price: 345000,
    amount: 345000,
    type: "fixed",
    linkType: "cause-service",
    revenue30d: 345000,
    successRate: 100,
    lastUsed: subHours(new Date(), 12),
    lastUsedAt: subHours(new Date(), 12).toISOString(),
    created: subDays(new Date(), 5).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/invoice-2847",
    shortCode: "inv-2847",
    views: 8,
    viewsCount: 8,
    conversions: 1,
    conversionsCount: 1,
    totalRevenue: 345000,
    maxUses: 1,
    currentUses: 1,
    expiresAt: addDays(new Date(), 25).toISOString(),
    afterPaymentBehavior: "invoice",
  },
  {
    id: "plink_17",
    name: "Community Fund Drive",
    description: "Annual community fundraiser supporting local education initiatives.",
    status: "active",
    type: "donation",
    linkType: "cause-service",
    revenue30d: 45680,
    successRate: 58.3,
    lastUsed: subHours(new Date(), 3),
    lastUsedAt: subHours(new Date(), 3).toISOString(),
    created: subDays(new Date(), 14).toISOString(),
    updated: new Date().toISOString(),
    currency: "EUR",
    url: "https://pay.example.com/community-fund",
    shortCode: "comm-fund",
    views: 2100,
    viewsCount: 2100,
    conversions: 122,
    conversionsCount: 122,
    totalRevenue: 45680,
    minimumAmount: 200,
    maximumAmount: 250000,
    presetAmounts: "1000,2500,5000,10000,25000",
    afterPaymentBehavior: "confirmation",
  },
  {
    id: "plink_18",
    name: "Premium API Access",
    description: "Unlock premium API tier with higher rate limits and advanced endpoints.",
    status: "active",
    price: 9900,
    amount: 9900,
    type: "subscription",
    linkType: "cause-service",
    revenue30d: 217800,
    successRate: 91.4,
    lastUsed: subHours(new Date(), 1),
    lastUsedAt: subHours(new Date(), 1).toISOString(),
    created: subDays(new Date(), 55).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/premium-api",
    shortCode: "api-prem",
    views: 4200,
    viewsCount: 4200,
    conversions: 384,
    conversionsCount: 384,
    totalRevenue: 217800,
    paymentDescriptor: "ACME*API",
    allowSaveCard: true,
    afterPaymentBehavior: "redirect",
    successUrl: "https://api.example.com/dashboard",
  },
  {
    id: "plink_19",
    name: "Vintage Collection Sale",
    status: "inactive",
    price: 79900,
    amount: 79900,
    type: "one-time",
    linkType: "products-subscriptions",
    revenue30d: 0,
    successRate: 76.2,
    lastUsed: subDays(new Date(), 8),
    lastUsedAt: subDays(new Date(), 8).toISOString(),
    created: subDays(new Date(), 65).toISOString(),
    updated: new Date().toISOString(),
    deactivated: subDays(new Date(), 4),
    currency: "GBP",
    url: "https://pay.example.com/vintage-collection",
    shortCode: "vintage-sale",
    views: 920,
    viewsCount: 920,
    conversions: 0,
    conversionsCount: 0,
    totalRevenue: 0,
    cartItems: JSON.stringify([
      { id: "vin_1", name: "Vintage Watch - 1960s Omega", description: "Original condition, serviced", price: 45000, quantity: 1 },
      { id: "vin_2", name: "Leather Watch Strap", description: "Italian calfskin, brown", price: 4900, quantity: 1 },
      { id: "vin_3", name: "Watch Display Case", description: "Walnut wood, glass top", price: 30000, quantity: 1 },
    ]),
  },
  {
    id: "plink_20",
    name: "Gym Membership Renewal",
    description: "Monthly gym membership with access to all facilities and group classes.",
    status: "active",
    price: 4999,
    amount: 4999,
    type: "subscription",
    linkType: "cause-service",
    revenue30d: 174965,
    successRate: 88.9,
    lastUsed: subHours(new Date(), 5),
    lastUsedAt: subHours(new Date(), 5).toISOString(),
    created: subDays(new Date(), 35).toISOString(),
    updated: new Date().toISOString(),
    currency: "EUR",
    url: "https://pay.example.com/gym-renewal",
    shortCode: "gym-renew",
    views: 3100,
    viewsCount: 3100,
    conversions: 275,
    conversionsCount: 275,
    totalRevenue: 174965,
    paymentDescriptor: "FITCLUB*MEMBER",
    allowSaveCard: true,
    afterPaymentBehavior: "confirmation",
  },
  {
    id: "plink_21",
    name: "Charity Gala Ticket",
    description: "Black-tie charity gala dinner including 3-course meal, live entertainment, and silent auction.",
    status: "active",
    price: 150000,
    amount: 150000,
    type: "fixed",
    linkType: "products-subscriptions",
    revenue30d: 2250000,
    successRate: 94.2,
    lastUsed: subHours(new Date(), 7),
    lastUsedAt: subHours(new Date(), 7).toISOString(),
    created: subDays(new Date(), 18).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/charity-gala-ticket",
    shortCode: "gala-2026",
    views: 680,
    viewsCount: 680,
    conversions: 64,
    conversionsCount: 64,
    totalRevenue: 2250000,
    maxUses: 200,
    currentUses: 64,
    expiresAt: addDays(new Date(), 30).toISOString(),
    allowShippingDetails: false,
    allowPhoneNumber: true,
    requirePhoneNumber: true,
    afterPaymentBehavior: "confirmation",
    cartItems: JSON.stringify([
      { id: "gala_1", name: "Gala Dinner Seat", description: "Individual seat at reserved table", price: 125000, quantity: 1 },
      { id: "gala_2", name: "Silent Auction Catalog", description: "Printed auction item catalog", price: 2500, quantity: 1 },
      { id: "gala_3", name: "Valet Parking", description: "Complimentary valet service", price: 22500, quantity: 1 },
    ]),
  },
  {
    id: "plink_22",
    name: "Expired Flash Sale",
    status: "blocked",
    price: 1999,
    amount: 1999,
    type: "one-time",
    linkType: "cause-service",
    revenue30d: 0,
    successRate: 0,
    lastUsed: subDays(new Date(), 30),
    created: subDays(new Date(), 95).toISOString(),
    updated: new Date().toISOString(),
    deactivated: subDays(new Date(), 30),
    currency: "USD",
    url: "https://pay.example.com/flash-sale-expired",
    views: 1200,
    conversions: 0,
    totalRevenue: 0,
    expiresAt: subDays(new Date(), 30).toISOString(),
  },
  {
    id: "plink_23",
    name: "Online Course Bundle",
    description: "Complete 12-module online course bundle covering full-stack development.",
    status: "active",
    price: 34900,
    amount: 34900,
    type: "one-time",
    linkType: "products-subscriptions",
    revenue30d: 523500,
    successRate: 85.1,
    lastUsed: subHours(new Date(), 2),
    lastUsedAt: subHours(new Date(), 2).toISOString(),
    created: subDays(new Date(), 22).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/course-bundle",
    shortCode: "course-bundle",
    views: 2800,
    viewsCount: 2800,
    conversions: 238,
    conversionsCount: 238,
    totalRevenue: 523500,
    afterPaymentBehavior: "redirect",
    successUrl: "https://learn.example.com/enroll",
    cartItems: JSON.stringify([
      { id: "crs_1", name: "Frontend Fundamentals", description: "HTML, CSS, JavaScript basics", price: 9900, quantity: 1 },
      { id: "crs_2", name: "React & TypeScript Mastery", description: "Advanced React patterns", price: 14900, quantity: 1 },
      { id: "crs_3", name: "Backend with Node.js", description: "REST APIs, databases, auth", price: 10100, quantity: 1 },
    ]),
  },
  {
    id: "plink_24",
    name: "Pet Shelter Donation",
    description: "Support our local pet shelter. Funds go directly to food, medical care, and shelter maintenance.",
    status: "active",
    type: "donation",
    linkType: "cause-service",
    revenue30d: 18920,
    successRate: 62.4,
    lastUsed: subHours(new Date(), 6),
    lastUsedAt: subHours(new Date(), 6).toISOString(),
    created: subDays(new Date(), 70).toISOString(),
    updated: new Date().toISOString(),
    currency: "USD",
    url: "https://pay.example.com/pet-shelter",
    shortCode: "pet-help",
    views: 1650,
    viewsCount: 1650,
    conversions: 103,
    conversionsCount: 103,
    totalRevenue: 18920,
    minimumAmount: 500,
    maximumAmount: 25000,
    presetAmounts: "500,1000,2500,5000",
    afterPaymentBehavior: "confirmation",
  },
  {
    id: "plink_25",
    name: "White-Label Platform Fee",
    description: "Enterprise white-label platform licensing fee.",
    status: "active",
    price: 499900,
    amount: 499900,
    type: "subscription",
    linkType: "cause-service",
    revenue30d: 999800,
    successRate: 100,
    lastUsed: subDays(new Date(), 1),
    lastUsedAt: subDays(new Date(), 1).toISOString(),
    created: subDays(new Date(), 8).toISOString(),
    updated: new Date().toISOString(),
    currency: "EUR",
    url: "https://pay.example.com/whitelabel-fee",
    shortCode: "wl-fee",
    views: 12,
    viewsCount: 12,
    conversions: 2,
    conversionsCount: 2,
    totalRevenue: 999800,
    maxUses: 5,
    currentUses: 2,
    paymentDescriptor: "ACME*WHITELABEL",
    allowSaveCard: true,
    allowPhoneNumber: true,
    requirePhoneNumber: true,
    afterPaymentBehavior: "invoice",
  },
]
